import { sendServerRequest } from "../../server/request";

export const HS_AGENT = '/server/humansales';
export const HS_ADMIN = '/server/admin/humansales';

/** Chamada às rotas de atendimento: devolve `data.data` e transforma erro do servidor em Error com a mensagem. */
export async function hsRequest<T = any>(method: 'GET' | 'POST' | 'PUT' | 'DELETE', path: string, body?: object, query?: Record<string, string | number | undefined | null>): Promise<T> {
    let url = path;
    if (query) {
        const qs = new URLSearchParams();
        Object.entries(query).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') qs.set(k, String(v)); });
        const s = qs.toString();
        if (s) url += `?${s}`;
    }
    try {
        const r = await sendServerRequest(method, url, body);
        return r.data?.data as T;
    } catch (e: any) {
        let msg = 'Erro inesperado. Tente novamente.';
        try {
            const b = JSON.parse(e?.target?.responseText || 'null');
            if (b?.error && b.error !== 'I-E') msg = String(b.error);
            else if (e?.target?.status === 403) msg = 'Sem permissão para esta ação.';
        } catch (_) { /* resposta sem JSON */ }
        throw new Error(msg);
    }
}

export const centsToReais = (c?: number | null) => (c || 0) / 100;
/** "12,50" / "12.50" → centavos inteiros (NaN se inválido). */
export function reaisInputToCents(v: string): number {
    const n = Number(String(v).trim().replace(/\./g, '').replace(',', '.'));
    return Number.isFinite(n) ? Math.round(n * 100) : NaN;
}
export function newIdempotencyKey(): string {
    // @ts-ignore
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    return `${Date.now()}-${Math.random().toString(16).slice(2)}-${Math.random().toString(16).slice(2)}`;
}
export function timeAgo(v?: string | Date | null): string {
    if (!v) return '-';
    const min = Math.max(0, Math.round((Date.now() - new Date(v).getTime()) / 60000));
    if (min < 1) return 'agora';
    if (min < 60) return `${min} min`;
    const h = Math.floor(min / 60);
    return h < 24 ? `${h} h ${min % 60} min` : `${Math.floor(h / 24)} d`;
}
export const PRODUCT_LABEL: Record<string, string> = { fgts: 'FGTS', clt: 'CLT' };
export const CHANNEL_LABEL: Record<string, string> = { whatsapp: 'WhatsApp', instagram: 'Instagram', evolution: 'WhatsApp (Evolution)', telegram: 'Telegram' };
export const CLOSE_REASON_LABEL: Record<string, string> = {
    no_interest: 'Sem interesse', no_answer: 'Não respondeu', wrong_person: 'Pessoa errada',
    already_resolved: 'Já resolveu por outro meio', ineligible: 'Inelegível', other: 'Outro',
};
export const SOURCE_LABEL: Record<string, string> = {
    human_sales: 'Atendimento (comissão)', manual_adjustment: 'Ajuste manual', manual_payment: 'Pagamento',
    propostal_comission: 'Comissão FGTS', clt_propostal: 'Comissão CLT',
};
